export const text = ['5rem', '1rem', '0.5rem']